const ROLES_ENUM = Object.freeze({
  TPV_MANAGER: "TPV_MANAGER",
  ACCESS_CAJA: "ACCESS_CAJA",
  ALLOW_CLOSE_TABLE: "ALLOW_CLOSE_TABLE",
  HELP_MANAGER: "HELP_MANAGER",
  PROFILE_MANAGER: "PROFILE_MANAGER",
  PROFILE_GENERAL_SETTINGS: "PROFILE_GENERAL_SETTINGS",
  PROFILE_CHANGE_PASSWORD: "PROFILE_CHANGE_PASSWORD",
  PROFILE_NOTIFICATIONS: "PROFILE_NOTIFICATIONS",
  PROFILE_SESSIONS: "PROFILE_SESSIONS",
  PROFILE_SUBSCRIPCION: "PROFILE_SUBSCRIPCION",
  PROFILE_INVOICES: "PROFILE_INVOICES",
  RESTAURANT_MANAGER: "RESTAURANT_MANAGER",
  RESTAURANT_TABLE_MANAGER: "RESTAURANT_TABLE_MANAGER",
  RESTAURANT_PRINTER_MANAGER: "RESTAURANT_PRINTER_MANAGER",
  RESTAURANT_BOOKING_MANAGER: "RESTAURANT_BOOKING_MANAGER",
  RESTAURANT_DISCOUNT_MANAGER: "RESTAURANT_DISCOUNT_MANAGER",
  RESTAURANT_EMPLOYEE_MANAGER: "RESTAURANT_EMPLOYEE_MANAGER",
  RESTAURANT_SESSIONS_MANAGER: "RESTAURANT_SESSIONS_MANAGER",
  RESTAURANT_PAYMENT_METHODS_MANAGER: "RESTAURANT_PAYMENT_METHODS_MANAGER",
  INVENTARY_MANAGER: "INVENTARY_MANAGER",
  INVENTARY_PRODUCT_MANAGER: "INVENTARY_PRODUCT_MANAGER",
  INVENTARY_CATEGORIES_MANAGER: "INVENTARY_CATEGORIES_MANAGER",
  INVENTARY_TAGS_MANAGER: "INVENTARY_TAGS_MANAGER",
  INVENTARY_DISPLAYS_MANAGER: "INVENTARY_DISPLAYS_MANAGER",
  // 2026-08-24 · Sub-items de Inventario > Escandallo (premium con addon).
  // Sin este permiso, Dashboard/Operaciones no se pintan en el nav.
  INVENTARY_GESTION_MANAGER: "INVENTARY_GESTION_MANAGER",
  BILLING_MANAGER: "BILLING_MANAGER",
  BILLING_CUSTOMERS_MANAGER: "BILLING_CUSTOMERS_MANAGER",
  BILLING_ANALYTICS_MANAGER: "BILLING_ANALYTICS_MANAGER",
  BILLING_INVOICES_MANAGER: "BILLING_INVOICES_MANAGER",
  BILLING_ACTIVITY_MANAGER: "BILLING_ACTIVITY_MANAGER",
  SETTINGS_MANAGER: "SETTINGS_MANAGER",
  SETTINGS_STRIPE_MANAGER: "SETTINGS_STRIPE_MANAGER",
  SETTINGS_ACCESS: "SETTINGS_ACCESS",
  // 2026-08-24 · Granularidad de sub-items de Ajustes que antes no
  // tenían gate (aparecían siempre aunque el rol no los tuviera).
  SETTINGS_MONITOR_ACCESS: "SETTINGS_MONITOR_ACCESS",
  SETTINGS_AUDIT_ACCESS: "SETTINGS_AUDIT_ACCESS",
  SETTINGS_AEAT_ACCESS: "SETTINGS_AEAT_ACCESS",
  MONEY_BOX_ALLOWED: "MONEY_BOX_ALLOWED",
  ALLOW_DELETE_PRODUCTS: "ALLOW_DELETE_PRODUCTS",
  ALLOW_COBRO: "ALLOW_COBRO",
  ALLOW_MAKE_ARQUEO: "ALLOW_MAKE_ARQUEO",
  // Add-on "Pedidos" (carta QR y futuros canales). Acción nueva del
  // catálogo backend (grupo Orders); aquí para que el dueño sin rol la
  // tenga en `permissions` (pass-through = Object.values(ROLES_ENUM)).
  ORDERS_MANAGE: "ORDERS_MANAGE",
  // Auditoría > Actividad del TPV (diario de actividad). Acción del
  // catálogo backend; aquí para que el dueño sin rol la tenga.
  AUDIT_TPV_VIEW: "AUDIT_TPV_VIEW",
  // Reservas: ver reservas (antes no se exigía) y configurar reservas.
  BOOKING_VIEW: "BOOKING_VIEW",
  BOOKING_SETTINGS: "BOOKING_SETTINGS",
  // Add-on "Promociones" (fidelización): gestionar promociones, aplicar
  // recompensas en el TPV y ajustar sellos a mano.
  LOYALTY_MANAGE: "LOYALTY_MANAGE",
  LOYALTY_REDEEM: "LOYALTY_REDEEM",
  LOYALTY_ADJUST: "LOYALTY_ADJUST",
  LOYALTY_STAMP: "LOYALTY_STAMP",
  // Promociones horarias (Happy Hour): crear/editar/activar reglas de
  // precio por franja (Carta › Promociones horarias).
  PRICE_RULES_MANAGE: "PRICE_RULES_MANAGE",
});

export default ROLES_ENUM;
